import {
    EXPORT_MESSAGE_ARCHIVE_REQUEST,
    EXPORT_MESSAGE_ARCHIVE
} from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';

export const getExportMessageArchiveAction = getApiActionCreator(EXPORT_MESSAGE_ARCHIVE);

export const exportMessageArchiveRequest = (payload) => ({
    type: EXPORT_MESSAGE_ARCHIVE_REQUEST,
    ...payload
});
